import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fd3adeec")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheMarketItem = _resolveComponent("TheMarketItem")
  const _component_AsyncNullableList = _resolveComponent("AsyncNullableList")
  const _component_Holder = _resolveComponent("Holder")
  const _component_Scroller = _resolveComponent("Scroller")

  return (_openBlock(), _createBlock(_component_Scroller, { class: "fill" }, {
    default: _withId(() => [
      _createVNode(_component_Holder, {
        content: _ctx.items,
        "holder-class": _ctx.holderClass
      }, {
        default: _withId(() => [
          _createVNode(_component_AsyncNullableList, {
            identify: v => v.code,
            "list-data": _ctx.items,
            as: "table",
            class: "mt-8",
            "list-class": "table-list",
            onRefresh: _ctx.load
          }, {
            default: _withId(({ item }) => [
              _renderSlot(_ctx.$slots, "default", { item: item }, () => [
                _createVNode(_component_TheMarketItem, { "market-item": item }, null, 8, ["market-item"])
              ], true)
            ]),
            _: 1
          }, 8, ["identify", "list-data", "onRefresh"])
        ]),
        _: 1
      }, 8, ["content", "holder-class"])
    ]),
    _: 1
  }))
})